import React from 'react';

const PromotionalBanners = () => {
  return (
    <section className="py-8 sm:py-12">
      <div className="">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {/* Première bannière - Collection de boissons fraîches */}
          <div className="relative overflow-hidden rounded-xl sm:rounded-2xl bg-gradient-to-r from-[#E5502E] to-[#8A250E] p-4 sm:p-6 h-32 sm:h-36 md:h-40 flex items-center">
            <div className="flex-1 text-left text-white z-10">
              <h3 className="text-base xl:text-lg font-bold mb-2 sm:mb-3 md:mb-4 leading-tight">
                Collection de boissons fraîches
              </h3>
              <button className="text-xs text-left sm:text-sm hover:underline transition-colors flex items-center gap-1">
                Achetez maintenant →
              </button>
            </div>

            <div className="flex-1 flex justify-start items-center">
              <div className="relative">
                <img
                  src="/images/categories/fruit.png"
                  alt="Collection de boissons fraîches"
                  className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain"
                />
              </div>
            </div>
          </div>

          {/* Deuxième bannière - Collection de chaussures pour hommes */}
          <div className="relative overflow-hidden rounded-xl sm:rounded-2xl bg-gradient-to-r from-[#0E8A5D] via-[#54E5A7] to-teal-300 p-4 sm:p-6 h-32 sm:h-36 md:h-40 flex items-center">
            <div className="flex-1 text-left text-white z-10">
              <h3 className="text-base xl:text-lg font-bold mb-2 sm:mb-3 md:mb-4 leading-tight">
                Collection de chaussures pour hommes
              </h3> 
              <button className="text-xs text-left sm:text-sm hover:underline transition-colors flex items-center gap-1">
                Achetez maintenant →
              </button>
            </div>

            <div className="flex-1 flex justify-end items-center">
              <div className="relative">
                <img
                  src="/images/categories/chaussures.png"
                  alt="Collection de chaussures pour hommes"
                  className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain"
                />
              </div>
            </div>
          </div>

          {/* Troisième bannière - Meilleure collection de casques audio */}
          <div className="relative overflow-hidden rounded-xl sm:rounded-2xl bg-gradient-to-r from-[#8A4600] to-[#FEA244] p-4 sm:p-6 h-32 sm:h-36 md:h-40 flex items-center sm:col-span-2 lg:col-span-1">
            <div className="flex-1 text-left text-white z-10">
              <h3 className="text-base xl:text-lg font-bold mb-2 sm:mb-3 md:mb-4 leading-tight">
                Meilleure collection de casques audio
              </h3>
            <button className="text-xs text-left sm:text-sm hover:underline transition-colors flex items-center gap-1">
                Achetez maintenant →
              </button>
            </div>

            <div className="flex-1 flex justify-end items-center">
              <div className="relative">
                <img
                  src="/images/categories/ecouteurs.png"
                  alt="Meilleure collection de casques audio"
                  className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 xl:w-32 xl:h-32 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalBanners; 